// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  margin: 0rem 5rem;
  padding: 0;
}
@media screen and (max-width: 576px) {
  ion-grid {
    margin: 0.5rem;
  }
}
ion-grid::ng-deep .reward-state-main-container {
  margin-top: 0px;
}
ion-grid::ng-deep .multi-rate-container {
  row-gap: 12px;
  margin-top: 17px;
}

.tab-container {
  display: flex;
  margin: auto;
  width: 50%;
  text-align: center;
}
@media screen and (max-width: 568px) {
  .tab-container {
    width: 60%;
  }
}
.tab-container .tab-style {
  flex: 1;
  font-family: var(--font-secondary);
  font-style: normal;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: var(--ion-color-secondary);
  cursor: pointer;
}
@media screen and (max-width: 568px) {
  .tab-container .tab-style {
    font-size: 11px;
  }
}
@media (max-height: 956px) {
  .tab-container .tab-style {
    font-size: 11px;
  }
}
.tab-container .selected {
  text-decoration: underline;
  color: rgb(19, 133, 191);
  text-underline-offset: 5px;
  text-decoration-thickness: 3px;
}

.rate-info-container {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  row-gap: 10px;
}
@media (max-height: 956px) {
  .rate-info-container {
    margin-top: 6px;
    row-gap: 6px;
  }
}
.rate-info-container span {
  font-family: var(--font-secondary);
  font-style: normal;
}
.rate-info-container .highlight-style {
  font-weight: 900;
  font-size: 12px;
  line-height: 18px;
}
@media (max-height: 956px) {
  .rate-info-container .highlight-style {
    font-size: 10px;
    line-height: 16px;
  }
}
.rate-info-container .text-style {
  font-weight: 500;
  font-size: 11px;
  line-height: 18px;
}
@media (max-height: 956px) {
  .rate-info-container .text-style {
    font-size: 9px;
    line-height: 16px;
  }
}
.rate-info-container p {
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}
@media (max-height: 956px) {
  .rate-info-container p {
    font-size: 12px;
    line-height: 18px;
  }
}
.rate-info-container p a {
  color: var(--ion-color-secondary);
  text-decoration: underline;
}

.spinner-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  color: var(--ion-color-secondary);
}
.spinner-container span {
  font-weight: 500;
  font-size: 11px;
}
.spinner-container ion-spinner {
  color: var(--ion-color-secondary);
  margin: 10% auto auto auto;
}

ion-row {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/starcard-convert/starcard-convert.page.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,UAAA;AACJ;AACI;EAJJ;IAKQ,cAAA;EAEN;AACF;AACQ;EACI,eAAA;AACZ;AACQ;EACI,aAAA;EACA,gBAAA;AACZ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AADJ;AAGI;EANJ;IAOQ,UAAA;EAAN;AACF;AAEI;EACI,OAAA;EACA,kCAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;AAAR;AAEQ;EAXJ;IAYQ,eAAA;EACV;AACF;AACQ;EAfJ;IAgBQ,eAAA;EAEV;AACF;AACI;EACI,0BAAA;EACA,wBAAA;EACA,0BAAA;EACA,8BAAA;AACR;;AAGA;EAEI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AADJ;AAGI;EAPJ;IAQQ,eAAA;IACA,YAAA;EAAN;AACF;AAEI;EACI,kCAAA;EACA,kBAAA;AAAR;AAII;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAFR;AAIQ;EALJ;IAMQ,eAAA;IACA,iBAAA;EADV;AACF;AAII;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAFR;AAIQ;EALJ;IAMQ,cAAA;IACA,iBAAA;EADV;AACF;AAII;EACI,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAKQ;EATJ;IAUQ,eAAA;IACA,iBAAA;EAFV;AACF;AAIQ;EACI,iCAAA;EACA,0BAAA;AAFZ;;AAQA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iCAAA;AALJ;AAOI;EACI,gBAAA;EACA,eAAA;AALR;AAQI;EACI,iCAAA;EACA,0BAAA;AANR;;AAUA;EAEI,sBAAA;EAEA,sBAAA;EAEA,yBAAA;AAPJ;AAoBA;EACI;IACI,UAAA;EATN;EAYE;IACI,UAAA;EAVN;AACF","sourcesContent":["ion-grid {\n    margin: 0rem 5rem;\n    padding: 0;\n\n    @media screen and (max-width:576px) {\n        margin: .5rem;\n    }\n\n    &::ng-deep {\n        .reward-state-main-container {\n            margin-top:0px;\n        }\n        .multi-rate-container {\n            row-gap: 12px;\n            margin-top: 17px;\n        }\n    }\n}\n\n.tab-container {\n    display: flex;\n    margin: auto;\n    width: 50%;\n    text-align: center;\n\n    @media screen and (max-width: 568px) {\n        width: 60%;\n    }\n\n    .tab-style {\n        flex: 1;\n        font-family: var(--font-secondary);\n        font-style: normal;\n        text-transform: uppercase;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 24px;\n        color: var(--ion-color-secondary);\n        cursor: pointer;\n\n        @media screen and (max-width: 568px) {\n            font-size: 11px;\n        }\n\n        @media (max-height: 956px) {\n            font-size: 11px;\n        }\n    }\n\n    .selected {\n        text-decoration: underline;\n        color: rgba(19, 133, 191, 1);\n        text-underline-offset: 5px;\n        text-decoration-thickness: 3px;\n    }\n}\n\n.rate-info-container {\n\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n    row-gap: 10px;\n\n    @media (max-height: 956px) {\n        margin-top: 6px;\n        row-gap: 6px;\n    }\n\n    span {\n        font-family: var(--font-secondary);\n        font-style: normal;\n\n    }\n\n    .highlight-style {\n        font-weight: 900;\n        font-size: 12px;\n        line-height: 18px;\n\n        @media (max-height: 956px) {\n            font-size: 10px;\n            line-height: 16px;\n        }\n    }\n\n    .text-style {\n        font-weight: 500;\n        font-size: 11px;\n        line-height: 18px;\n\n        @media (max-height: 956px) {\n            font-size: 9px;\n            line-height: 16px;\n        }\n    }\n\n    p {\n        font-family: var(--font-primary);\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #000000;\n\n\n        @media (max-height: 956px) {\n            font-size: 12px;\n            line-height: 18px;\n        }\n\n        a {\n            color: var(--ion-color-secondary);\n            text-decoration: underline;\n        }\n    }\n}\n\n\n.spinner-container {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n    color: var(--ion-color-secondary);\n\n    span {\n        font-weight: 500;\n        font-size: 11px;\n    }\n\n    ion-spinner {\n        color: var(--ion-color-secondary);\n        margin: 10% auto auto auto;\n    }\n}\n\nion-row {\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
